export default {
    title: 'Chữ cơ bản',
    intro: `Chữ cơ bản giúp bạn học được nguyên tắc và quá trình hình thành từ <br>bằng cách xem xét 'chữ' và 'từ được viết bằng chữ đó'. Thông qua <br>luyện tập Chữ cơ bản, bạn có thể dễ dàng suy ra nghĩa của từ chưa biết.`,
    quizIntro: 'Hãy nhớ lại những chữ đã học và giải câu hỏi nhé.',
    header: {
        navigator: 'Cấp độ {level} Lần {round}',
    },
    subject: {
        letter: 'Học Chữ cơ bản',
        relation: 'Xác nhận mối quan hệ ý nghĩa',
        board: 'Chữ cơ bản tôi đã học',
        lesson: 'Luyện tập Chữ cơ bản',
        quiz: 'Bài kiểm tra Chữ cơ bản',
    },
    indicator: {
        letter: 'Học hình dạng, âm thanh và ý nghĩa của Chữ cơ bản bằng cách nhấp vào chữ.',
        word: 'Học cách Chữ cơ bản được sử dụng trong từ bằng cách nhấp vào từ.',
        words: 'Học hai từ có chứa Chữ cơ bản.',
        choose1: 'Hai từ dưới đây có chữ cái chung. <br/>',
        choose2: "Trong hai từ, từ nào sử dụng chữ 'word'?",
        relation: 'Mối quan hệ ý nghĩa giữa hai Chữ cơ bản là gì?',
        quiz: 'Chữ nào phù hợp để điền vào chỗ trống?',
    },
    study: {
        example: 'Câu ví dụ',
        meaning: 'Nghĩa',
        sound: 'Âm thanh',
        listen: 'Nghe âm thanh',
    },
    modal: {
        notCompleted: 'Bạn có thể học sau khi hoàn thành tất cả các bài học của lần trước.',
        moveToWaiting: 'Bạn có muốn chuyển đến Phòng chờ không?',
        invalidAccess: 'Truy cập không hợp lệ.',
    },
    exitModal: {
        title: 'Bài tập chưa kết thúc!',
        message: 'Nếu dừng bây giờ, nội dung luyện tập có thể không được lưu!',
        continue: 'Tiếp tục',
        stop: 'Dừng lại',
    },
    result: {
        totalQuestionMessage: 'Bạn đã trả lời đúng score trong tổng số total câu hỏi.',
        checkMessage: 'Hãy kiểm tra kỹ tất cả các đáp án đúng.',
        correct: 'Đúng',
        selected: 'Đã chọn',
        incorrect: 'Sai',
    },
    button: {
        nextWord: 'Học tiếp theo',
        nextLevel: 'Lên cấp độ tiếp theo',
        start: 'Bắt đầu',
        finishStudy: 'Kết thúc học tập',
        finishExam: 'Kết thúc bài kiểm tra',
        confirm: 'Xác nhận',
    },
    relation: {
        synonym: { name: 'Đồng nghĩa', description: 'Hai chữ có hình dạng khác nhau   nhưng nghĩa tương tự' },
        opposite: { name: 'Trái nghĩa', description: 'Hai chữ có nghĩa  trái ngược nhau' },
        hierarchy: { name: 'Bao hàm', description: 'Nghĩa của một chữ  bao gồm nghĩa của chữ kia' },
        same: { name: 'Đồng âm', description: 'Hai chữ có âm giống nhau  nhưng nghĩa khác nhau' },
        different: { name: 'Đa nghĩa', description: 'Một chữ  có nhiều nghĩa khác nhau' },
    },
};
